import { Component, OnInit } from '@angular/core';
import { WaitLoadingService } from '../components/common/waitLoading/wait-loading.service';
import { BaseComponent } from '../components/common/baseComponent/base.component';
import { HeaderActionsService } from '../components/common/sub-header/header-actions.service';
import { ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Location } from '@angular/common';

@Component({
  selector: 'errorVisualizacion',
  templateUrl: 'errorVisualizacion.template.html'
})
export class errorVisualizacionComponent extends BaseComponent implements OnInit {
  constructor(
    public waitService: WaitLoadingService,
    private headerActionsService: HeaderActionsService,
    private route: Router,
    private location: Location,
    public translate: TranslateService,
    private elem: ElementRef) {

    super();
  }



  ngOnInit() {

    this.waitService.cancelWaiting();
  }

  ngAfterContentInit(): void {
    this.setHeaderNuevo();
    this.setActionButtons();

  }

  private setHeaderNuevo(txt?: string) {
    // *****
    this.headerActionsService.setTaskDescription(
      this.elem,
      txt
        ? this.translate.instant('General.access.visualizationDenied.title') + ': ' + txt
        : this.translate.instant('General.access.visualizationDenied.title'),
      'fa-eye-slash',
      true
    );
  }

  public cancel() {
    this.route.navigate(['/dossiersView/EXP']);
  }

  private setActionButtons() {
    this.waitService.startWaiting();
    this.headerActionsService.clearActions();
    this.headerActionsService.addDivider();
    this.subscribe(this.headerActionsService
      .addAction(
        'General.back',
        //'fas fa-lg fa-backward',
        'fas fa-chevron-left',
        'btn-outline-secondary',
        true
      ), () => {
        this.cancel();
      });
    this.waitService.cancelWaiting();
  }

}
